import { createBrowserRouter } from "react-router-dom";
import Home from "./components/nav Components/Home";
import Signup from './components/auth/Signup';
import Login from './components/auth/Login';
import Verify from "./components/auth/Verify";
import LandingPageHome from "./components/landing Components/Landing-Page";
import Settings from "./components/nav Components/Settings";
import Logout from "./components/auth/Logout";
import Profile from "./components/nav Components/Profile";
import ProjectNetworks from "./components/nav Components/ProjectNetworks";
import NetworkProfile from "./components/extra/Profile";
import RecruiterHome from "./recruiter Components/nav Components/Home";
import RecruiterSettings from "./recruiter Components/nav Components/Settings";
import RecruiterProfile from "./recruiter Components/nav Components/MyProfile";
import CompanyProfile from "./recruiter Components/nav Components/Profile";
import RecruiterSignup from './recruiter Components/auth/Signup';
import RecruiterLogin from './recruiter Components/auth/Login';
import RecruiterVerify from "./recruiter Components/auth/Verify";
import RecruiterLogout from "./recruiter Components/auth/Logout";
import AllMyJobs from "./recruiter Components/nav Components/All-My-Jobs";
import PostedJobs from "./recruiter Components/nav Components/PostedJobs";
// import RecruiterJobDetails from "./recruiter Components/job Components/Job";
import Job1 from "./recruiter Components/job Components/Job1-pagination";
import AppliedInterns from "./components/nav Components/Applied-Interns";
import MessagesPage from "./components/nav Components/Messages";
import Application from "./recruiter Components/application/application";
import JobDetails from "./components/job Components/JobDetails.js";
import MessagesRecruiterPage from "./recruiter Components/nav Components/Messages";
import ApplicantToRecruiterMessage from "./components/nav Components/ApplicantToRecruiterMessage";
import AllMessages from './components/nav Components/AllMessages';
import GuestHome from "./components/guest Components/nav Components/Home";
import GuestJobDetails from "./components/guest Components/job Components/JobDetails.js";
import GuestProjectNetworks from "./components/guest Components/nav Components/ProjectNetworks";
import GuestMessagesPage from "./components/guest Components/nav Components/Messages";
import GuestProfile from "./components/guest Components/nav Components/Profile";
import GuestSettings from "./components/guest Components/nav Components/Settings";
import GuestApplicantToRecruiterMessage from "./components/guest Components/nav Components/ApplicantToRecruiterMessage.js";
import GuestAppliedInterns from "./components/guest Components/nav Components/Applied-Interns.js";
import Social from "./components/nav Components/Social.js";
import Groups from "./components/social/Groups.js";
// import GuestGroups from "./components/guest Components/social/Groups.js";
import GroupProfile from "./components/social/GroupProfile.js";
// import GuestGroupProfile from "./components/guest Components/social/GroupProfile.js";
import Clubs from "./components/social/Clubs.js";
// import GuestClubs from "./components/guest Components/social/Clubs.js";
import ClubProfile from "./components/social/ClubProfile.js";
// import GuestClubProfile from "./components/guest Components/social/ClubProfile.js";
import Channels from "./components/social/Channels.js";
// import GuestChannels from "./components/guest Components/social/Channels.js";
import ChannelProfile from "./components/social/ChannelProfile.js";
// import GuestChannelProfile from "./components/guest Components/social/ChannelProfile.js"; 
import NotificationPage from "./components/nav Components/Notification.js";
import ClubInviteLinkPage from "./components/extra/invites/ClubInviteLinkPage.js";
import GroupInviteLinkPage from "./components/extra/invites/GroupInviteLinkPage.js";
import ChannelInviteLinkPage from "./components/extra/invites/ChannelInviteLinkPage.js";
import LearnTeach from "./components/nav Components/LearnTeach.js";
import LearnTeachSearch from  "./components/extra/LearnTeachSearch";
import OfferView from "./components/extra/OfferView.js";
import ForgetPassword from "./components/auth/Forget-Password.js";
import ResetPassword from "./components/auth/Reset-Password.js";

const routes = createBrowserRouter([
  {
    path: "/",
    element: <LandingPageHome />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/guest/home",
    element: <GuestHome />,
  },

  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    // path: "/project-networks",
    // element: <ProjectNetworks />,
  },
  {
    path: "/verify",
    element: <Verify />,
  },
  {
    path: "/forget-password",
    element: <ForgetPassword />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/applied-interns",
    element: <AppliedInterns />,
  },
  {
    path: "/guest/applied-interns",
    element: <GuestAppliedInterns />,
  },
  {
    path: "/job-details/:jobId",
    element: <JobDetails />,
  },
  {
    path: "/guests/job-details/:jobId",
    element: <GuestJobDetails />,
  },
  {
    path: "/messages",
    element: <MessagesPage />,
  },
  {
    path: "/guest/messages",
    element: <GuestMessagesPage />,
  },
  {
    path: "/all-messages",
    element: <AllMessages />,
  },
  {
    path: "/recruiter-messages",
    element: <ApplicantToRecruiterMessage />,
  },
  {
    path: "/guest/recruiter-messages",
    element: <GuestApplicantToRecruiterMessage />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/notifications",
    element: <NotificationPage />,
  },
  {
    path: "/guest/profile",
    element: <GuestProfile />,
  },
  {
    path: "/settings", 
    element: <Settings />,
  },
  {
    path: "/guest/settings", 
    element: <GuestSettings />,
  },
  {
    path: "/logout",
    element: <Logout />,
  },
  {
    path: "/verify",
    element: <Verify />,
  },
  {
    path: "/recruiter/home",
    element: <RecruiterHome />,
  },

  {
    path: "/recruiter/login",
    element: <RecruiterLogin />,
  },
  {
    path: "/recruiter/signup",
    element: <RecruiterSignup />,
  },
  {
    path: "/project-networks",
    element: <ProjectNetworks />,
  },
  {
    path: "/guest/project-networks",
    element: <GuestProjectNetworks />,
  },
  {
    path: "/profile/:networkId",
    element: <NetworkProfile />,
  },    
  {
    path: "/recruiter/verify",
    element: <RecruiterVerify />,
  },
  {
    path: "/recruiter/profile",
    element: <RecruiterProfile />,
  },
  {
    path: "/recruiter/company-profile",
    element: <CompanyProfile />,
  },
  {
    path: "/recruiter/settings", 
    element: <RecruiterSettings />,
  },
  {
    path: "/recruiter/logout",
    element: <RecruiterLogout />,
  },
  {
    path: "/recruiter/all-my-jobs",
    element: <AllMyJobs />,
  },
  {
    path: "/recruiter/live-posted-jobs",
    element: <PostedJobs />,
  },
  // {
  //   path: "/recruiter/job-details/:jobId",
  //   element: <RecruiterJobDetails />,
  // },
  {
    path: "/recruiter/job-details/:jobId",
    element: <Job1 />,
  },
  {
    path: "/recruiter/messages",
    element: <MessagesRecruiterPage />,
  },
  {
    path: "/recruiter/applications/:applicationId",
    element: <Application/>,
  },

  //social
  {
    path: "/social",
    element: <Social />,
  },
  
  // {
  //   path: "/guest/social",
  //   element: <GuestSocial />,
  // },
  {
    path: "/learn-teach",
    element: <LearnTeach/>,
  },
  {
    path: "/lnt/search",
    element: <LearnTeachSearch/>,
  },
  {
    path: "/offer/view/:offerId",
    element: <OfferView/>,
  },
// Groups Routes
  {
    path: "/groups",
    element: <Groups />,
  },
  // {
  //   path: "/guest/groups",
  //   element: <GuestGroups />,
  // },
  {
    path: "/group/:groupId",
    element: <GroupProfile />,
  },
  {
    path: "/group/invite-link/:token",
    element: <GroupInviteLinkPage />,
  },
  // {
  //   path: "/guest/group/:groupId",
  //   element: <GuestGroupProfile />,
  // },

// Clubs Routes
  {
    path: "/clubs",
    element: <Clubs />,
  },
  // {
  //   path: "/guest/clubs",
  //   element: <GuestClubs />,
  // },
  {
    path: "/club/:clubId",
    element: <ClubProfile />,
  },
  {
    path: "/club/invite-link/:token",
    element: <ClubInviteLinkPage />,
  },
  // {
  //   path: "/guest/club/:groupId",
  //   element: <GuestClubProfile />,
  // },

// Channels Routes
  {
    path: "/channels",
    element: <Channels />,
  },
  // {
  //   path: "/channels",
  //   element: <GuestChannels />,
  // },
  {
    path: "/channel/:channelId",
    element: <ChannelProfile />,
  },
  {
    path: "/channel/invite-link/:token",
    element: <ChannelInviteLinkPage />,
  },
  // {
  //   path: "/guest/Channel/:groupId",
  //   element: <GuestChannelProfile />,
  // },


]);

export default routes;
